// NOTE: This file consists of data which are hardcoded at FE now but will bw consumed later from BE and will be removed later

export const LOCAL_FOOTER_INFO = [
  {
    links: [
      {
        title: "International Flights",
        url: "https://www.makemytrip.com/international-flights/",
      },
      {
        title: "Hotels",
        url: "https://www.makemytrip.com/hotels/",
      },
      {
        title: "International Hotels",
        url: "https://www.makemytrip.com/hotels-international/",
      },
      {
        title: "Holiday Packages",
        url: "https://www.makemytrip.com/holidays-india/",
      },
      {
        title: "International Holiday Packages",
        url: "https://www.makemytrip.com/holidays-international/",
      },
      {
        title: "Travel Insurance",
        url: "https://www.makemytrip.com/insurance",
      },
      {
        title: "Book Bus Ticket",
        url: "https://www.makemytrip.com/bus-tickets/",
      },
      {
        title: "Book Train Ticket",
        url: "https://www.makemytrip.com/railways/",
      },
      {
        title: "Cab Booking",
        url: "https://www.makemytrip.com/cabs/",
      },
      {
        title: "MICE",
        url: "https://www.makemytrip.com/mice",
      },
      {
        title: "myBiz",
        url: "https://mybiz.makemytrip.com/",
      },
      {
        title: "myPartner",
        url: "https://mypartner.makemytrip.com/",
      },
      {
        title: "Gift Card",
        url: "https://www.makemytrip.com/gift-cards/",
      },
      {
        title: "MakeMyTrip UAE",
        url: "https://apps.apple.com/ae/app/makemytrip-travel-booking-app/id530488359",
      },
    ],
    title: "Our Product",
    type: "section",
  },
  {
    links: [
      {
        title: "Dubai Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/uae-dirham",
      },
      {
        title: "Kuwait Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/kuwaiti-dinar",
      },
      {
        title: "Qatar Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/qatari-riyal",
      },
      {
        title: "Russian Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/russian-ruble",
      },
      {
        title: "Indonesia Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/indonesian-rupiah",
      },
      {
        title: "Malaysia Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/malaysian-ringgit",
      },
      {
        title: "United Kingdom",
        url: "- UK Currency   https://www.makemytrip.com/tripmoney/currency/pound",
      },
      {
        title: "Canada Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/canadian-dollar",
      },
      {
        title: "China Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/chinese-yuan-renminbi",
      },
      {
        title: "Japan Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/japanese-yen",
      },
      {
        title: "United States",
        url: "- US Currency   https://www.makemytrip.com/tripmoney/currency/us-dollar",
      },
      {
        title: "Saudi Arabia Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/saudi-arabian-riyal",
      },
      {
        title: "Singapore Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/singapore-dollar",
      },
      {
        title: "Thailand Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/thai-baht",
      },
      {
        title: "Germany Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/euro",
      },
      {
        title: "Oman Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/omani-rial",
      },
      {
        title: "Sri lanka Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/sri-lankan-rupee",
      },
      {
        title: "Ukraine Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/ukrainian-hryvnia",
      },
      {
        title: "Australlia Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/australian-dollar",
      },
      {
        title: "bahrain Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/bahraini-dinar",
      },
      {
        title: "Switzerland  Currency",
        url: "https://www.makemytrip.com/tripmoney/currency/swiss-franc",
      },
    ],
    title: "Top Currency",
    type: "section",
  },
  {
    links: [
      {
        title: "Currency Exchange In Bangalore",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-bangalore",
      },
      {
        title: "Currency Exchange In Delhi",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-delhi",
      },
      {
        title: "Currency Exchange In Noida",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-noida",
      },
      {
        title: "Currency Exchange In Gurgaon",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-gurgaon",
      },
      {
        title: "Currency Exchange In Hyderabad",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-hyderabad",
      },
      {
        title: "Currency Exchange In Pune",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-pune",
      },
      {
        title: "Currency Exchange In Kolkata",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-kolkata",
      },
      {
        title: "Currency Exchange In Mumbai",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-mumbai",
      },
      {
        title: "Currency Exchange In Ahmedabad",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-ahemadabad",
      },
      {
        title: "Currency Exchange In Chennai",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-chennai",
      },
      {
        title: "Currency Exchange In Jaipur",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-jaipur",
      },
      {
        title: "Currency Exchange In Chandigarh",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-chandigarh",
      },
      {
        title: "Currency Exchange In Lucknow",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-lucknow",
      },
      {
        title: "Currency Exchange In Vijayawada",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-vijayawada",
      },
      {
        title: "Currency Exchange In Coimbatore",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-coimbatore",
      },
      {
        title: "Currency Exchange In Vadodara",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-vadodara",
      },
      {
        title: "Currency Exchange In Surat",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-surat",
      },
      {
        title: "Currency Exchange In Thane",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-thane",
      },
      {
        title: "Currency Exchange In Guwahati",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-guwahati",
      },
      {
        title: "Currency Exchange In Bhopal",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-bhopal",
      },
      {
        title: "Currency Exchange In Faridabad",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-faridabad",
      },
      {
        title: "Currency Exchange In Patna",
        url: "https://www.makemytrip.com/tripmoney/currency-exchange-in-patna",
      },
    ],
    title: "Currency Exchange in City",
    type: "section",
  },
  {
    items: [
      {
        links: [
          {
            imageurl:
              "https://tripmoneycmsimgak.mmtcdn.com/img/twitter_Icon_760f145ad2.png",
            type: "image-link",
            url: "https://insurance.makemytrip.com/insurance?startDate=1692697767\u0026endDate=1692784167\u0026travellers=1#",
          },
          {
            imageurl:
              "https://tripmoneycmsimgak.mmtcdn.com/img/fb_Icon_8eab71f726.png",
            type: "image-link",
            url: "https://www.facebook.com/tripmoneymmt/",
          },
          {
            imageurl:
              "https://tripmoneycmsimgak.mmtcdn.com/img/Linkedin_Icon_fec59ba5c7.png",
            type: "image-link",
            url: "https://www.linkedin.com/company/trip-money",
          },
        ],
        type: "social-links",
      },
      {
        type: "copyright",
        value: "\u0026copy; 2026 Makemytrip Pvt. Ltd. \nCountry, India",
      },
    ],
    type: "footnote",
  },
];

export const LOCAL_QnA_INFO = [
  {
    ques: "How to buy travel insurance online with MakeMyTrip?",
    info: "Buying travel insurance is simple on MakeMyTrip. All you need to do first is to download our app on your Android or iOS device or simply use your computer. On the app, tap on insurance section. Choose your preferred coverage plan and add it to your package. You can review benefits and coverage details before confirming. Complete your booking and your travel insurance policy details will be sent to your email instantly.",
  },
  {
    ques: "How to find the best travel insurance plan for my trip?",
    info: "MakeMyTrip offers multiple travel insurance plans, tailored to your destination and trip duration. Use the filters on our platform to select based on coverage amount, medical benefits, baggage protection, or adventure activity coverage. You can compare plans side by side, and view full policy details before making a choice.",
  },
  {
    ques: "How to file a travel insurance claim with MakeMyTrip?",
    info: "Filing a travel insurance claim is hassle-free with MakeMyTrip. For TATA AIG policies, you can notify your claim by sending an SMS, calling the 24x7 helpline, or emailing the claims department. Gather all necessary documents like your claim form, travel tickets, medical records, and receipts. Submit them to the Tata AIG claims team using the provided address or email. The insurance company will review your claim and documents, and any further steps or requirements will be shared with you. Claims are settled within 30 days after submission of all required paperwork. Always check your policy document for the detailed checklist and claim guidance.",
  },
  {
    ques: "Where can I find detailed coverage and exclusions for my travel insurance?",
    info: "All coverage details, inclusions, and exclusions for MakeMyTrip travel insurance plans are displayed on the policy information page before checkout. Click “View Details” next to any plan to see full coverage, claims process, and exclusions. After purchase, your policy document and certificate will be emailed to you, or accessible through your Manage Booking section for future reference.",
  },
];

export const LOCAL_CONTENT_BLOCK_INFO = [
  {
    heading: "How to buy travel insurance online with MakeMyTrip?",
    description:
      "Buying travel insurance is simple on MakeMyTrip. Follow these steps:<ul><li>Download our app on your Android or iOS device or simply use your computer</li><li>On the app, tap on insurance section</li><li>Choose your preferred coverage plan and add it to your package</li><li>Review benefits and coverage details before confirming</li><li>Complete your booking and your travel insurance policy details will be sent to your email instantly</li></ul>",
  },
  {
    heading: "How to find the best travel insurance plan for my trip?",
    description:
      "MakeMyTrip offers multiple travel insurance plans, tailored to your destination and trip duration. Here's how to find the best plan:<ul><li>Use the filters on our platform to select based on coverage amount</li><li>Consider medical benefits, baggage protection, or adventure activity coverage</li><li>Compare plans side by side</li><li>View full policy details before making a choice</li></ul>",
  },
  {
    heading: "How to file a travel insurance claim with MakeMyTrip?",
    description:
      "Filing a travel insurance claim is hassle-free with MakeMyTrip. For TATA AIG policies, follow these steps:<ul><li>Notify your claim by sending an SMS, calling the 24x7 helpline, or emailing the claims department</li><li>Gather all necessary documents like your claim form, travel tickets, medical records, and receipts</li><li>Submit them to the Tata AIG claims team using the provided address or email</li><li>The insurance company will review your claim and documents, and any further steps or requirements will be shared with you</li><li>Claims are settled within 30 days after submission of all required paperwork</li><li>Always check your policy document for the detailed checklist and claim guidance</li></ul>",
  },
  {
    heading:
      "Where can I find detailed coverage and exclusions for my travel insurance?",
    description:
      "All coverage details, inclusions, and exclusions for MakeMyTrip travel insurance plans are displayed on the policy information page before checkout. Click 'View Details' next to any plan to see full coverage, claims process, and exclusions. After purchase, your policy document and certificate will be emailed to you, or accessible through your Manage Booking section for future reference.",
  },
  {
    heading: "How to file a travel insurance claim with MakeMyTrip?",
    description:
      "Filing a travel insurance claim is hassle-free with MakeMyTrip. For TATA AIG policies, you can notify your claim by sending an SMS, calling the 24x7 helpline, or emailing the claims department. Gather all necessary documents like your claim form, travel tickets, medical records, and receipts. Submit them to the Tata AIG claims team using the provided address or email. The insurance company will review your claim and documents, and any further steps or requirements will be shared with you. Claims are settled within 30 days after submission of all required paperwork. Always check your policy document for the detailed checklist and claim guidance.",
  },
  {
    heading:
      "Where can I find detailed coverage and exclusions for my travel insurance?",
    description:
      "All coverage details, inclusions, and exclusions for MakeMyTrip travel insurance plans are displayed on the policy information page before checkout. Click “View Details” next to any plan to see full coverage, claims process, and exclusions. After purchase, your policy document and certificate will be emailed to you, or accessible through your Manage Booking section for future reference.",
  },
  {
    heading: "How to file a travel insurance claim with MakeMyTrip?",
    description:
      "Filing a travel insurance claim is hassle-free with MakeMyTrip. For TATA AIG policies, you can notify your claim by sending an SMS, calling the 24x7 helpline, or emailing the claims department. Gather all necessary documents like your claim form, travel tickets, medical records, and receipts. Submit them to the Tata AIG claims team using the provided address or email. The insurance company will review your claim and documents, and any further steps or requirements will be shared with you. Claims are settled within 30 days after submission of all required paperwork. Always check your policy document for the detailed checklist and claim guidance.",
  },
  {
    heading:
      "Where can I find detailed coverage and exclusions for my travel insurance?",
    description:
      "All coverage details, inclusions, and exclusions for MakeMyTrip travel insurance plans are displayed on the policy information page before checkout. Click “View Details” next to any plan to see full coverage, claims process, and exclusions. After purchase, your policy document and certificate will be emailed to you, or accessible through your Manage Booking section for future reference.",
  },
];

export const LOCAL_TERMS_AND_CONDITIONS = {
  heading: "DISCLAIMER",
  body: `MMT has integrated with Symbo India Insurance Broking Private Limited having its insurance broking license number and validity: CA0599 / Valid up to 25th September 2025, to list Symbo’s insurance products for sale through the platform. Travel Agent Partners may purchase these insurance products through the Symbo’s dedicated page for its end users.<br/><br/>
  The Travel Agent Partner acknowledges and agrees that the purchase of the insurance products is made directly from Symbo, at their sole discretion. Therefore, the relationship for the purchase of the insurance products is strictly between the Travel Agent Partner and Symbo. MMT shall not be held responsible for any sale of the insurance products made through the platform.<br/><br/>
  Furthermore, the Travel Agent Partner understands that MMT is neither soliciting the sale of Symbo’s insurance products nor making any payments to Symbo in connection with these sales.<br/><br/>
  All insurance certificates resulting from the sale of insurance products through the platform shall be issued in accordance with the applicable laws. Symbo will be solely responsible for addressing any grievances arising from such sale of insurance products.`,
};

export const LOCAL_LANDING_BENEFITS = [
  {
    icon: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_2147223348_3x_1_dd9dbf9d95.png",
    title: "No KYC",
  },
  {
    icon: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_2147223348_3x_2_ca6d4d0383.png",
    title: "Use myCash to buy",
  },
  {
    icon: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_2147223348_3x_2fdd1619e6.png",
    title: "Pay only net amount",
    // subtitle: "Pay only net amount",
  },
];

// TODO: Remove once BE sends tripOptions in PLAN_CARDS data
export const HARDCODED_LISTING_TRIP_OPTIONS = [
  {
    id: "SINGLETRIP",
    name: "Single Trip",
  },
  {
    id: "MULTITRIP",
    name: "Annual Multi Trip",
    icon: "https://i.ibb.co/MbmFX8m/Info.png",
    subTitle: {
      text: [{ value: "Save upto 60%" }],
    },
    bottomSheetData: {
      heading: {
        title: { text: {} },
        subTitle: { text: {} },
        img: "https://i.ibb.co/TMRWn6RP/Image-c0d5ec30cf.jpg",
        deskImg:
          "https://tripmoneycmsimgak.mmtcdn.com/img/Image_c2aa097331.png",
      },
      list: [
        {
          icon: "",
          title: {
            text: [
              { value: "Unlimited trips ", styles: { fontWeight: "900" } },
              { value: "for one year, each covered up to 30 days " },
            ],
          },
        },
        {
          icon: "",
          title: { text: [{ value: "Global coverage" }] },
        },
        {
          icon: "",
          title: {
            text: [
              { value: "Upto 80% cheaper", styles: { fontWeight: "900" } },
              { value: " than regular plans" },
            ],
          },
        },
        {
          icon: "",
          title: {
            text: [{ value: "Automatic protection on every departure" }],
          },
        },
        {
          icon: "",
          title: {
            text: [{ value: "Recommended for frequent travellers" }],
          },
        },
        {
          icon: "",
          title: {
            text: [{ value: "Valid for travellers aged 18 to 70 years" }],
          },
        },
      ],
      ctaText: {
        title: { text: { value: "EXPLORE ANNUAL INSURANCE" } },
      },
    },
    // popOverData: {
    //   icon: "",
    //   title: {
    //     text: [
    //       {
    //         value: "Travelling frequently to International Destinations?",
    //       },
    //     ],
    //   },
    //   subTitle: {
    //     text: [
    //       {
    //         value: "Save up to 60% with Annual Multi-Trip Insurance.",
    //       },
    //     ],
    //   },
    // },
  },
];
